import styled from 'styled-components';

const StyledModalButtonWrapper = styled.div`
  width: 100%;
  height: fit-content;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

export default StyledModalButtonWrapper;
